module.exports = __webpack_public_path__ + "img/83.160dbd95.jpg";